import React from 'react';

import FacebookIcon from '../../../../assets/facebook-icon.svg';
import LinkedinIcon from '../../../../assets/linkedin-icon.svg';
import InstagramIcon from '../../../../assets/instagram-icon.svg';
import TwitterIcon from '../../../../assets/twitter-icon.svg';
import { SocialLinkTypes } from '../../../../types/user.types';

interface SocialLinksProps {
  links?: SocialLinkTypes;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ links }) => {
  if (!links) return null;

  const socialIcons = [
    { key: 'facebook', icon: FacebookIcon, link: links.facebook },
    { key: 'twitter', icon: TwitterIcon, link: links.twitter },
    { key: 'linkedin', icon: LinkedinIcon, link: links.linkedin },
    { key: 'instagram', icon: InstagramIcon, link: links.instagram }
  ].filter((social) => social.link);

  return (
    <div className="flex gap-1 md:gap-2 items-center">
      {socialIcons.map(({ key, icon: Icon, link }) => (
        <a
          key={key}
          href={link.startsWith('http') ? link : `https://${link}`}
          className="cursor-pointer hover:opacity-80"
          target="_blank"
          rel="noreferrer"
        >
          <img className="w-4 h-4" src={Icon} alt={key} />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
